import React from "react";
import AdminDashboardComponent from "../../components/Admin/AdminDashboardComponent";

import "../../assets/styles/admin/admindashboard.scss";

const AdminDashboard = (props) => {
  return <AdminDashboardComponent />
};

export default AdminDashboard;
